import { mapMutations } from 'vuex';

export default {
  methods: {
    ...mapMutations('title', {
      setTitle: 'set',
      emptyTitle: 'empty',
    }),
  },
};
